/**
 * chapman-snize-compare - the "Comparer" control on the collection cards.
 *
 * The collection grid is rendered by Searchanise, not by the theme, so the
 * theme's own compare button never appears on a card. It does not need to be
 * rebuilt: the theme's compare is driven entirely by
 *
 *   - an element carrying .m-compare-button and data-product-handle
 *   - addEventDelegate, which is DELEGATED, so an element added to the page
 *     long after init is handled with no rebinding
 *   - localStorage['m-compare-products'], read by the header counter and by
 *     /pages/product-compare
 *
 * So all this does is put a correctly shaped control into each card and keep it
 * in sync. Clicking it was verified to toggle storage and the counter without
 * navigating, even though the control sits inside the card's wrapping <a>:
 * the theme's handler calls preventDefault, and Searchanise nests its own
 * <button> in that anchor already.
 *
 * The handle comes from the card's own product link rather than any data
 * attribute, because the app does not expose one.
 */
(function () {
  'use strict';

  var MARK = 'chap-cmp';
  var LABEL = (window.ChapmanCompareStrings || {}).add || 'Compare';
  var observer = null;

  function handleOf(card) {
    var a = card.querySelector('a.snize-view-link[href]');
    if (!a) return null;
    var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function decorate(card) {
    if (card.querySelector('.' + MARK)) return;
    var host = card.querySelector('.snize-buttons-bottom') || card.querySelector('.snize-buttons');
    if (!host) return;
    var handle = handleOf(card);
    if (!handle) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = MARK + ' m-compare-button';
    btn.setAttribute('data-product-handle', handle);
    btn.setAttribute('aria-pressed', 'false');

    var box = document.createElement('span');
    box.className = MARK + '__box';
    box.setAttribute('aria-hidden', 'true');

    var txt = document.createElement('span');
    txt.className = MARK + '__txt';
    txt.textContent = LABEL;

    btn.appendChild(box);
    btn.appendChild(txt);

    /* first child, so it lands in the grid row the stock ::before occupies and
       the add-to-cart button stays on its own row below */
    host.insertBefore(btn, host.firstChild);
  }

  /* the theme toggles .added-to-compare; mirror that onto aria-pressed, which
     it knows nothing about */
  function syncAria() {
    var all = document.querySelectorAll('.' + MARK);
    for (var i = 0; i < all.length; i++) {
      all[i].setAttribute('aria-pressed', all[i].classList.contains('added-to-compare') ? 'true' : 'false');
    }
  }

  function sweep() {
    var cards = document.querySelectorAll('.snize-product');
    if (!cards.length) return;

    /* stop observing while we write, or our own inserts re-trigger the sweep */
    if (observer) observer.disconnect();
    for (var i = 0; i < cards.length; i++) decorate(cards[i]);
    if (observer) observe();

    var cp = window.MinimogTheme && window.MinimogTheme.CompareProduct;
    if (cp) {
      /* restores the ticks after the app re-renders on filter, sort or paging */
      cp.setCompareButtonsState();
      cp.updateCompareCount();
    }
    syncAria();
  }

  /* A plain debounce starved here: this page mutates continuously (lazy images,
     the chat widget, the app's own paint), so clearTimeout kept pushing the
     sweep back and it never ran. This is a THROTTLE - the wait shrinks as time
     passes since the last run, so a steady stream of mutations still lets it
     fire at least every RUN_EVERY ms. */
  var RUN_EVERY = 150;
  var lastRun = 0;
  var pending = null;
  function schedule() {
    var wait = Math.max(0, RUN_EVERY - (Date.now() - lastRun));
    clearTimeout(pending);
    pending = setTimeout(function () {
      lastRun = Date.now();
      sweep();
    }, wait);
  }

  function observe() {
    var root = document.getElementById('snize_results') || document.body;
    observer.observe(root, { childList: true, subtree: true });
  }

  function start() {
    sweep();
    observer = new MutationObserver(schedule);
    observe();
    /* The observer is the mechanism; these are the safety net, for the case
       where the app finishes painting in one batch we happen to miss. sweep()
       is idempotent, so running it a few extra times costs nothing. */
    [300, 800, 2000, 4000].forEach(function (ms) { setTimeout(sweep, ms); });
    /* compare-product.js is loaded earlier in theme.liquid and both are defer,
       so its document listener is registered first and has already applied
       .added-to-compare by the time this runs: syncing here is correct without
       waiting. The timeout is kept only in case that order ever changes. */
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('.' + MARK)) {
        syncAria();
        setTimeout(syncAria, 0);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
